export enum SelectedRoleEnum {
  /**
   * 导师
   */
  Mentor = 'mentor',
  /**
   * 学院
   */
  Dean = 'dean',
  /**
   * 教务
   */
  AcademicAffairs = 'academic_affairs',
  /**
   * 书院
   */
  EducationalSupervisor = 'educational_supervisor',
  /**
   * 全校
   */
  SchoolLeaders = 'school_leaders',
  /**
   * 预科部
   */
  Yuke = 'yuke',
  /**
   * 行政班导师
   */
  AdminclassMentor = 'adminclass_mentor',
}
